
import { Loader, SessionProfileAttribute, SessionProfileQueryBinding } from "./session";
import { Assigner, MatchConfig } from "./assignment";

export default class Refresher 
{

    public static execute(
        queries: Array<SessionProfileQueryBinding>,
        leadSourceConfiguration: MatchConfig,
    ) : void
    {
        console.debug('Refreshing input queries...');
        // initialize and load a session data profile   
        let sessionProfile = Loader.execute();

        // assign lead sources to the profile
        sessionProfile = Assigner.execute(leadSourceConfiguration, sessionProfile);

        // dispatch an event letting other code know
        // that session profile data, including lead source, is available for querying
        window.dispatchEvent(new CustomEvent('Fountain.SessionProfile.Loaded', {detail: sessionProfile}));

        // execute all queries, refreshing values of form inputs, on an interval
        for(let i = 0; i < queries.length; i ++) {
            const query = queries[i].query;
            const attribute = query.attribute;
            if (attribute === SessionProfileAttribute.allValues) {
                queries[i].element.value = JSON.stringify(sessionProfile);
            } else {
                if (typeof(sessionProfile[attribute]) !== 'undefined') {
                    const index = query.index;
                    if (sessionProfile[attribute].length >= (index + 1)) {
                        let replacement = sessionProfile[attribute][index];
                        if (typeof(replacement) !== 'string') {
                            replacement = JSON.stringify(replacement);
                        }
                        queries[i].element.value = replacement;
                    } else {
                        queries[i].element.value = '';
                    }
                }
            }
        }
    }
}